export async function getSubmissions(booking:Booking) {
    console.log('get-submissions.ts')
    const reactAppData = window.react_data.api_url ? window.react_data : {api_url:'http://localhost:8000/api/v1/'};
    const endPoint = 'submission';

    let data = new FormData();
    data.append('call', 'submissions');
    data.append('booking', JSON.stringify(booking));

    return await fetch(reactAppData.api_url+endPoint, {body:data, method:'post'})
        .then(res => res.json())
        .then(
            (result) => {
                return result
            },
            (error) => {
                return {error:error}
            }
        );
}
